const state = {
  currentPath: [],
  theme: 'default'
};

const mutations = {
  updatePath(state, path) {
    state.currentPath = path;
  }
};

const actions = {
  setCurrentPath({ commit }, path) {
    /** Caro Mantenedor: Assim que você tiver terminado de tentar 'otimizar' essa rotina dos breadcrumbs, e tiver realizado que erro terrível que foi, por favor incremente o contador a seguir como um aviso para o próximo cara: total_hours_wasted_here = 3 **/
    commit('updatePath', path);
  }
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
